import type { ProductLogoMediumProps } from '../types';

/**
 * 中サイズのPermissionAndRolesロゴアイコン
 */
export function ProductLogoMediumPermissionAndRoles({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" rx="5.88235" fill="#1A2142" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.1238 9.99996C31.9461 8.39284 30.5836 7.14282 28.9291 7.14282C27.2746 7.14282 25.9121 8.39284 25.7345 9.99996H25.7148L25.7148 13.5119H32.1434L32.1434 9.99996H32.1238ZM30.7148 10.2561L30.7039 10.1569C30.6053 9.2656 29.8473 8.57139 28.9291 8.57139C28.0109 8.57139 27.2529 9.2656 27.1544 10.1569L27.1434 10.2561L27.1434 12.0833H30.7148L30.7148 10.2561Z"
        fill="#57D7D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.2863 11.4285C23.8918 11.4285 23.572 11.7483 23.572 12.1428V17.8571C23.572 18.2516 23.8918 18.5714 24.2863 18.5714H33.572C33.9665 18.5714 34.2863 18.2516 34.2863 17.8571V12.1428C34.2863 11.7483 33.9665 11.4285 33.572 11.4285H24.2863ZM28.9291 16.0714C29.5209 16.0714 30.0006 15.5917 30.0006 15C30.0006 14.4082 29.5209 13.9285 28.9291 13.9285C28.3374 13.9285 27.8577 14.4082 27.8577 15C27.8577 15.5917 28.3374 16.0714 28.9291 16.0714Z"
        fill="#57D7D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.9291 22.1428C25.9705 22.1428 23.572 24.5413 23.572 27.5C23.572 30.4586 25.9705 32.8571 28.9291 32.8571C31.8878 32.8571 34.2863 30.4586 34.2863 27.5C34.2863 24.5413 31.8878 22.1428 28.9291 22.1428ZM31.2897 25.3962C31.1037 25.2102 30.8022 25.2102 30.6162 25.3962L28.1247 27.8877L27.2998 27.0629C27.1138 26.8769 26.8123 26.8769 26.6264 27.0629L26.2897 27.3996C26.1037 27.5856 26.1037 27.8871 26.2897 28.073L27.788 29.5713C27.9739 29.7573 28.2754 29.7573 28.4614 29.5713L31.6264 26.4064C31.8123 26.2204 31.8123 25.9189 31.6264 25.7329L31.2897 25.3962Z"
        fill="#57D7D9"
      />
      <path
        d="M10.7148 15C10.7148 16.3807 9.59556 17.5 8.21484 17.5C6.83413 17.5 5.71484 16.3807 5.71484 15C5.71484 13.6193 6.83413 12.5 8.21484 12.5C9.59556 12.5 10.7148 13.6193 10.7148 15Z"
        fill="#FCFCFD"
      />
      <path
        d="M20.7148 14.2857C21.1093 14.2857 21.4291 14.6055 21.4291 15C21.4291 15.3945 21.1093 15.7142 20.7148 15.7142H13.572C13.1775 15.7142 12.8577 15.3945 12.8577 15C12.8577 14.6055 13.1775 14.2857 13.572 14.2857L20.7148 14.2857Z"
        fill="#FCFCFD"
      />
      <path
        d="M20.7148 27.1428C21.1093 27.1428 21.4291 27.4626 21.4291 27.8571C21.4291 28.2516 21.1093 28.5714 20.7148 28.5714H17.1434C16.7489 28.5714 16.4291 28.2516 16.4291 27.8571C16.4291 27.4626 16.7489 27.1428 17.1434 27.1428H20.7148Z"
        fill="#FCFCFD"
      />
      <path
        d="M17.8577 27.8571C17.8577 28.2516 17.5379 28.5714 17.1434 28.5714C16.7489 28.5714 16.4291 28.2516 16.4291 27.8571V15C16.4291 14.6055 16.7489 14.2857 17.1434 14.2857C17.5379 14.2857 17.8577 14.6055 17.8577 15L17.8577 27.8571Z"
        fill="#FCFCFD"
      />
    </svg>
  );
}
